import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { BoletosColaboradoresCarritoComponent } from '../boletos-colaboradores-carrito/boletos-colaboradores-carrito.component';
import { DatosCompradorComponent } from '../datos-comprador/datos-comprador.component';
import { ErrorPagoComponent } from '../error-pago/error-pago.component';
import { FormaPagoComponent } from '../forma-pago/forma-pago.component';
import { PagarComponent } from '../pagar/pagar.component';
import { VentaDigitalExternaComponent } from '../venta-digital-externa/venta-digital-externa.component';
import { VentaExitosaComponent } from '../venta-exitosa/venta-exitosa.component';
import { ModoLigaApp } from './modo-liga-app';

/**
 * Encierra al usuario de una liga (App o venta digital externa) en su flujo de pago
 * (ver ModoLigaApp).
 *
 * Se decide por COMPONENTE y no por path: 'pagar-boletos-en-linea' sin parámetros es
 * LoginComponent, pero con :id/:pk es PagarComponent.
 *
 * Al bloquear se le regresa a su liga original. Eso cubre de un jalón todas las salidas
 * al home que ya existen (timer vencido, "Terminar", "Seguir comprando", "Volver a
 * comprar", "Regresar" del carrito, el logo, el botón atrás del navegador y escribir
 * la URL a mano en la misma pestaña), sin tocar cada botón.
 */
@Injectable({ providedIn: 'root' })
export class ModoLigaAppGuard implements CanActivateChild {
  /** Liga de la App: no pasa por datos-comprador (tiposPago 2/3). */
  private static readonly PERMITIDOS_APP: any[] = [
    PagarComponent,
    BoletosColaboradoresCarritoComponent,
    FormaPagoComponent,
    VentaExitosaComponent,
    ErrorPagoComponent,
  ];

  /** Venta digital externa: su maquina + el flujo normal de compra (con datos-comprador). */
  private static readonly PERMITIDOS_EXTERNA: any[] = [
    VentaDigitalExternaComponent,
    PagarComponent, // abrir una liga de la App en la misma pestaña cambia de modo ahi mismo
    BoletosColaboradoresCarritoComponent,
    DatosCompradorComponent,
    FormaPagoComponent,
    VentaExitosaComponent,
    ErrorPagoComponent,
  ];

  constructor(private router: Router) {}

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
    if (!ModoLigaApp.activo()) return true;
    const permitidos = ModoLigaApp.tipo() === 'externa'
      ? ModoLigaAppGuard.PERMITIDOS_EXTERNA
      : ModoLigaAppGuard.PERMITIDOS_APP;
    if (permitidos.includes(childRoute.component)) return true;

    const origen = ModoLigaApp.origen();
    if (origen) return this.router.parseUrl(origen);

    // Modo activo sin liga guardada (no debería pasar): no hay a dónde regresarlo.
    ModoLigaApp.desactivar();
    return true;
  }
}
